/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Информация о подписанном документе
 */
export interface DocumentSendResponse {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Вид документа ВК */
  type?: string;

  /** Номер документа */
  number?: string;

  /** Статус документа */
  state?: string;
}

/**
 * Данные для сохранения документа
 */
export interface Revoke {
  /**
   * ИД отзываемого документа
   * @format uuid
   */
  documentRefTypeId?: string;

  /** Код типа документа */
  documentRefType?: string;

  /**
   * ИД типа документа
   * @format uuid
   */
  documentRefId?: string;

  /** Номер отзываемого документа */
  documentRefNumber?: string;

  /**
   * Дата отзываемого документа
   * @format date-time
   */
  documentRefDate?: string;

  /** Сумма документа */
  documentRefSum?: number;

  /** Валюта суммы */
  documentRefCurrCode?: string;

  /**
   * Идентификатор причины отзыва
   * @format uuid
   */
  reasonId?: string;

  /** Примечание к причине отзыва "Иное" */
  comment?: string;
}

/**
 * Данные сохраненного документа
 */
export interface DocumentSaveResponse {
  /** @format uuid */
  documentId: string;
}

/**
 * Привилегия
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  desc?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Получение деталей документа
 */
export interface RevokeDetailResponse {
  /**
   * ИД отзываемого документа
   * @format uuid
   */
  documentRefTypeId?: string;

  /** Код типа документа */
  documentRefType?: string;

  /**
   * ИД типа документа
   * @format uuid
   */
  documentRefId?: string;

  /** Номер отзываемого документа */
  documentRefNumber?: string;

  /**
   * Дата отзываемого документа
   * @format date-time
   */
  documentRefDate?: string;

  /** Сумма документа */
  documentRefSum?: number;

  /** Валюта суммы */
  documentRefCurrCode?: string;

  /**
   * Идентификатор причины отзыва
   * @format uuid
   */
  reasonId?: string;

  /** Примечание к причине отзыва "Иное" */
  comment?: string;

  /**
   * Идентификатор отзыва
   * @format uuid
   */
  id?: string;

  /** Номер отзыва */
  documentNumber?: string;

  /** Статус отзыва */
  state?: string;

  /** Причина отзыва */
  reasonName?: string;

  /**
   * Дата и время создания отзыва
   * @format date-time
   */
  createDate?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /** список привилегий пользователя */
  permissions?: PermissionResponse[];
}

/**
 * Список привилегий документа
 */
export interface PermissionListResponse {
  /** Тип документа */
  entityStrId?: string;

  /** Список разрешений */
  permissions?: PermissionResponse[];
}

/**
 * Причины отзыва документа
 */
export interface RevokeReasonResponse {
  /**
   * Идентификатор причины отзыва
   * @format uuid
   */
  id?: string;

  /** Наименование причины отзыва */
  name?: string;

  /** Сортировка на фронте */
  sorting?: string;

  /** Требуется расшифровка причины отзыва. Может отсутствовать в ответе, если в состоянии false */
  isOther?: boolean;

  /** Признак актуальности */
  isActive?: boolean;
}

/**
 * Документ
 */
export interface Document {
  /** Тип документа */
  type?: DocumentType;

  /** Поля документа */
  fields?: DocumentFields;
}

/**
 * Поля документа
 */
export type DocumentFields = OrderCcb;

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб документа
 */
export interface OrderCcb {
  /**
   * ИД отзываемого документа
   * @format uuid
   */
  documentRefTypeId?: string;

  /** Код типа документа */
  documentRefType?: string;

  /**
   * ИД типа документа
   * @format uuid
   */
  documentRefId?: string;

  /** Номер отзываемого документа */
  documentRefNumber?: string;

  /**
   * Дата отзываемого документа
   * @format date-time
   */
  documentRefDate?: string;

  /** Сумма документа */
  documentRefSum?: number;

  /** Валюта суммы */
  documentRefCurrCode?: string;

  /**
   * Идентификатор причины отзыва
   * @format uuid
   */
  reasonId?: string;

  /** Примечание к причине отзыва "Иное" */
  comment?: string;

  /**
   * Идентификатор отзыва
   * @format uuid
   */
  id?: string;

  /** Номер отзыва */
  documentNumber?: string;

  /** Статус отзыва */
  state?: string;

  /** Причина отзыва */
  reasonName?: string;

  /**
   * Дата и время создания отзыва
   * @format date-time
   */
  createDate?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: Document;
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-ved-cancel-doc
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Отзыв документов ВК <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=188150842)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Смена статуса и отправка
     * @name UpdateDocumentStatus
     * @summary Обновление статуса документа
     * @request POST:/api/ved-cancel-doc/v1/external/update-status/{type}/{id}
     * @secure
     */
    updateDocumentStatus: (
      type: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/update-status/${type}/${id}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Смена статуса и отправка
     * @name SendDocument
     * @summary Отправка подписанного документа в Банк
     * @request POST:/api/ved-cancel-doc/v1/external/send/{documentType}/{id}
     * @secure
     */
    sendDocument: (
      documentType: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSendResponse, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/send/${documentType}/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отзыв
     * @name CreateRevoke
     * @summary Создание отзыва документа
     * @request POST:/api/ved-cancel-doc/v1/external/revoking
     * @secure
     */
    createRevoke: (data: Revoke, params: RequestParams = {}) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/revoking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение информации об отзыве документа
     * @name GetRevokeControl
     * @summary Детальная информация об отзыве документа
     * @request GET:/api/ved-cancel-doc/v1/internal/control/revoking
     * @secure
     */
    getRevokeControl: (
      query: { docRefId: string },
      params: RequestParams = {}
    ) =>
      this.request<RevokeDetailResponse[], GenericError>({
        path: `/api/ved-cancel-doc/v1/internal/control/revoking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отзыв
     * @name GetRevoke
     * @summary Получение детальной информации
     * @request GET:/api/ved-cancel-doc/v1/external/revoking/{documentRefId}
     * @secure
     */
    getRevoke: (documentRefId: string, params: RequestParams = {}) =>
      this.request<RevokeDetailResponse, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/revoking/${documentRefId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение разрешений
     * @name GetPermissions
     * @summary Получение разрешений на документ
     * @request GET:/api/ved-cancel-doc/v1/external/permissions/{documentType}
     * @secure
     */
    getPermissions: (documentType: string, params: RequestParams = {}) =>
      this.request<PermissionListResponse, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/permissions/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetRevokeReasons
     * @summary Причины отзыва документа
     * @request GET:/api/ved-cancel-doc/v1/external/dict/revoke-reason
     * @secure
     */
    getRevokeReasons: (params: RequestParams = {}) =>
      this.request<RevokeReasonResponse[], GenericError>({
        path: `/api/ved-cancel-doc/v1/external/dict/revoke-reason`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/ved-cancel-doc/v1/external/confirmation/order-ccb/{documentType}/{documentId}
     * @secure
     */
    getOrderCcb: (
      documentId: string,
      documentType: string,
      params: RequestParams = {}
    ) =>
      this.request<OrderCcbResponse, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/confirmation/order-ccb/${documentType}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/ved-cancel-doc/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс управления сертификатами
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/ved-cancel-doc/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отзыв
     * @name DeleteRevoke
     * @summary Удаление
     * @request DELETE:/api/ved-cancel-doc/v1/external/revoking/{id}
     * @secure
     */
    deleteRevoke: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError>({
        path: `/api/ved-cancel-doc/v1/external/revoking/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
